import { Button } from '@brighterion/br-ui';
import { t } from 'i18next';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RoleService } from 'Services';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import RulesHeader from 'Components/RulesHeader';
import AddNewRuleButton from 'Components/RulesHeader/AddNewRuleButton';
import ButtonGroup from 'Components/ButtonGroup/ButtonGroup';
import styles from './TenantGroupPageHeader.css';

type TenantGroupPageHeaderProps = {
    tenantGroupId?: string;
    tenantGroupName?: string;
    disableViewDeployed?: boolean;
    mode?: 'tenantOverrideSelection' | 'deployed';
    deployedInfoText?: string;
};

const TenantGroupPageHeader = ({
    tenantGroupId,
    tenantGroupName,
    disableViewDeployed = true,
    mode,
    deployedInfoText
}: TenantGroupPageHeaderProps) => {
    const history = useHistory();
    const location = useLocation();

    return (
        <RulesHeader>
            <RulesHeader.Left
                isSandbox={mode !== 'deployed'}
                disableLink={disableViewDeployed}
                title={t('tenantGroupRulesHeader', { tenantGroupName })}
                useAlternateText={mode === 'tenantOverrideSelection'}
                alternateText={t('Select Rule to Add Override')}
                tenantGroupId={tenantGroupId}
            />
            <RulesHeader.Right>
                {mode === 'deployed' ? (
                    <span data-testid='deployed-info-text' className={styles.deployedInfoText}>
                        {deployedInfoText}
                    </span>
                ) : (
                    <ButtonGroup direction='row'>
                        {mode !== 'tenantOverrideSelection' && RoleService.hasTenantGroupWriteAccess && (
                            <>
                                <Button
                                    dataTestId='add-tenant-to-group'
                                    variant='tertiary'
                                    iconName='add-file'
                                    onClick={handleOnClickEvent(() => history.push(`${location.pathname}/add-tenant`))}
                                    onKeyDown={handleKeyEvent(() => history.push(`${location.pathname}/add-tenant`))}
                                >
                                    {t('Add Tenant To Group')}
                                </Button>
                                <hr className={styles.separator} />
                                {/* show only override */}
                                <AddNewRuleButton tenantGroupId={tenantGroupId} />
                            </>
                        )}
                        {mode === 'tenantOverrideSelection' && (
                            <Button
                                dataTestId='addForm-cancel-btn'
                                variant='secondary'
                                size='small'
                                onClick={handleOnClickEvent(() =>
                                    history.push(`/tenants/tenant-group/${tenantGroupId}`)
                                )}
                                onKeyDown={handleKeyEvent(() => history.push(`/tenants/tenant-group/${tenantGroupId}`))}
                            >
                                {t('Cancel')}
                            </Button>
                        )}
                    </ButtonGroup>
                )}
            </RulesHeader.Right>
        </RulesHeader>
    );
};

export default TenantGroupPageHeader;
